var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#c8c8c8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102.55 122.88",
    style: {
      enableBackground: "new 0 0 102.55 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.55,122.88H0V0h77.66l24.89,26.43V122.88L102.55,122.88z M19.36,42.93h41.87c1.9,0,3.46,1.55,3.46,3.45 v12.8l21.95-11.18v36.39L64.69,72.07v16.18c0,1.9-1.56,3.46-3.46,3.46H19.36c-1.9,0-3.46-1.55-3.46-3.46V46.38 C15.91,44.48,17.46,42.93,19.36,42.93L19.36,42.93z M37.22,55.43v23.78l11.89-11.89L37.22,55.43L37.22,55.43z M96.13,115.98V30.44 H72.49V5.91H6.51v110.07H96.13L96.13,115.98z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipManager);
export default __webpack_public_path__ + "static/media/clip-manager.d12804f0abc8e6b17028f1bd8b45f9c6.svg";
export { ForwardRef as ReactComponent };